import { render, staticRenderFns } from "./PerCollect.vue?vue&type=template&id=2461dc90&scoped=true&"
import script from "./PerCollect.vue?vue&type=script&lang=ts&"
export * from "./PerCollect.vue?vue&type=script&lang=ts&"
import style0 from "./PerCollect.vue?vue&type=style&index=0&id=2461dc90&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2461dc90",
  null
  
)

export default component.exports